export default "__VITE_ASSET__nvZ1Sai5__"